import React, {
  useState,
  useEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "./Card";
import { locToMap } from "../redux/actions/cardsActions";
import InfiniteScroll from "react-infinite-scroller";
import ProgressBar from "./ProgressBar";
import {
  NextFetchProfileCards,
  nextFetchMainCards,
  setHasMore
} from "../redux/actions/cardsActions";
import { CSSTransition, TransitionGroup } from "react-transition-group";

let prevLastCard = {};
const AllCards = ({ fromPage }) => {
  const locArr = [];
  const dispatch = useDispatch();
  const [lastCard, setLastCard] = useState("");
  const lastCardReducer = useSelector(state => state.cardsReducer.lastCard);
  const currentUser = useSelector(state => state.authReducer.userId);
  const mainCards = useSelector(state => state.cardsReducer.maincards);
  const profileCards = useSelector(state => state.cardsReducer.profileCards);
  let hasMore = useSelector(state => state.cardsReducer.hasMore);
  let maincardsListeners = useSelector(
    state => state.cardsReducer.maincardsListeners
  );
  let profileCardsListeners = useSelector(
    state => state.cardsReducer.profileCardsListeners
  );

  const selectedOptions = useSelector(
    state => state.homeReducer.selectedOptions
  );

  const [cards, setCards] = useState({});
  const [filteredCards, setFilteredCards] = useState({});

  const cardsFiltering = () => {
    let newCards = [];
    let province = selectedOptions.find(item => (item.prov ? item.prov : null));
    let onlyProv;
    selectedOptions.length === 1 && selectedOptions[0].prov
      ? (onlyProv = true)
      : (onlyProv = false);
    let provFilterd;
    if (selectedOptions[0].prov) {
      provFilterd = Object.keys(cards).filter(
        key => cards[key].prov === province.prov
      );
    }
    let cardsToFilter = selectedOptions[0].prov
      ? provFilterd
      : Object.keys(cards);
    cardsToFilter.map(key => {
      if (!onlyProv) {
        let g = 0;
        selectedOptions.map(sel => {
          Object.keys(cards[key].needs).some(need => {
            if (cards[key].needs[need].theNeed === sel.value) g = g + 1;
            return cards[key].needs[need].theNeed === sel.value;
          });
        });
        if (g > 0)
          newCards.push({ id: key, data: { ...cards[key], matches: g } });
      } else {
        newCards.push({ id: key, data: cards[key] });
      }
    });

    let sortedCards = [...newCards].sort((a, b) => {
      return b.data.matches - a.data.matches;
    });

    let finalCards = {};
    sortedCards.map(item => (finalCards[item.id] = item.data));
    setFilteredCards(finalCards);
  };

  useEffect(() => {
    if (selectedOptions.length) {
      cardsFiltering();
    }
  }, [selectedOptions]);

  useEffect(() => {
    if (
      (fromPage === "Dashboard" && mainCards !== null) ||
      (fromPage === "Dashboard" && Object.keys(mainCards).length !== 0)
    ) {
      setCards(mainCards);
      setLastCard(lastCardReducer);
    } else if (
      (fromPage === "UserActivities" && profileCards !== null) ||
      (fromPage === "UserActivities" && Object.keys(profileCards).length !== 0)
    ) {
      setCards(profileCards);
      setLastCard(lastCardReducer);
    }

    if (selectedOptions.length) {
      cardsFiltering();
    }
  }, [mainCards, profileCards]);

  const getNextPage = () => {
    if (
      (fromPage === "Dashboard" && maincardsListeners.length < 60) ||
      (fromPage === "UserActivities" && profileCardsListeners.length < 60)
    ) {
      if (lastCard && prevLastCard !== lastCard) {
        if (fromPage === "Dashboard") {
          prevLastCard = lastCard;
          dispatch(nextFetchMainCards(lastCard));
        } else if (fromPage === "UserActivities") {
          prevLastCard = lastCard;
          dispatch(NextFetchProfileCards(currentUser, lastCard));
        }
      }
    } else {
      dispatch(setHasMore(false));
    }
    dispatch(locToMap(locArr));
  };
  return (
    <div className="mx-auto relativ pt-12 pb-20 clearfix ">
      <br />
      {cards ? (
        <InfiniteScroll
          pageStart={0}
          loadMore={getNextPage}
          hasMore={hasMore}
          loader={
            <div
              className={` absolute bottom-0 ${fromPage === "UserActivities" ? "hidden" : ""
                }`}
              key={0}
            >
              <ProgressBar
                progress={77}
                size={60}
                strokeWidth={8}
                circleOneStroke="#d9edfe"
                circleTwoStroke="#7CD89F"
              />
            </div>
          }
          className="infiniteCard"
        >
          <TransitionGroup>
            {selectedOptions.length
              ? Object.keys(filteredCards).map(key => {
                return (
                  <CSSTransition key={key} timeout={800} classNames="fade">
                    <Card
                      cardInfo={cards[key]}
                      cardId={key}
                      key={key}
                      fromPage={fromPage}
                    />
                  </CSSTransition>
                );
                //}
              })
              : Object.keys(cards).map(key => {
                return (
                  <CSSTransition key={key} timeout={800} classNames="fade">
                    <Card
                      cardInfo={cards[key]}
                      cardId={key}
                      key={key}
                      fromPage={fromPage}
                    />
                  </CSSTransition>
                );
                //}
              })}
          </TransitionGroup>
        </InfiniteScroll>
      ) : null}
    </div>
  );
};
export default AllCards;
